// John Eldhose 20180516
const UserSession = (state = [], action) => {
  switch (action.type) {
    case 'USER_SESSION':
      return action.session;
    default:
  }
  return state;
};

export default UserSession;



// WEBPACK FOOTER //
// ./src/reducers/UserSession.js